(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giippa-burga-product"] && !Shopify.designMode) return;
  try {
    
  class GiippaBurgaProduct extends HTMLElement {
    connectedCallback() {
      this.variantSelect = this.querySelector('[data-gbp-variant-select]');
      this.addButtons = this.querySelectorAll('[data-gbp-add], [data-gbp-sticky-add]');
      this.priceTargets = this.querySelectorAll('[data-gbp-price], [data-gbp-sticky-price]');
      this.mainImage = this.querySelector('[data-gbp-main-image] img');
      this.sticky = this.querySelector('[data-gbp-sticky]');

      this.querySelectorAll('[data-gbp-mode]').forEach((button) => {
        button.addEventListener('click', () => this.selectMode(button));
      });

      this.querySelectorAll('[data-gbp-media-thumb]').forEach((button) => {
        button.addEventListener('click', () => this.selectMedia(button));
      });

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', () => this.updateVariant());
        this.updateVariant();
      }

      if (this.sticky) {
        this.observeSticky();
      }
    }

    selectMode(selectedButton) {
      this.querySelectorAll('[data-gbp-mode]').forEach((button) => {
        const isSelected = button === selectedButton;
        button.classList.toggle('gbp__tab--active', isSelected);
        button.setAttribute('aria-selected', String(isSelected));
      });
    }

    selectMedia(selectedButton) {
      const full = selectedButton.dataset.full;
      if (this.mainImage && full) {
        this.mainImage.src = full;
        this.mainImage.removeAttribute('srcset');
        this.mainImage.alt = selectedButton.dataset.alt || this.mainImage.alt;
      }

      this.querySelectorAll('[data-gbp-media-thumb]').forEach((button) => {
        const isSelected = button.dataset.full === full;
        button.classList.toggle('gbp__thumb--active', isSelected);
        button.classList.toggle('gbp__design--active', isSelected);
      });
    }

    updateVariant() {
      const option = this.variantSelect.selectedOptions[0];
      if (!option) return;

      const price = option.dataset.price || '';
      const available = option.dataset.available === 'true';

      this.priceTargets.forEach((target) => {
        target.textContent = price;
      });

      this.addButtons.forEach((button) => {
        button.disabled = !available;
      });
    }

    observeSticky() {
      const mainButton = this.querySelector('[data-gbp-add]');
      if (!mainButton || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });

      observer.observe(mainButton);
    }
  }

  if (!customElements.get('giippa-burga-product')) {
    customElements.define('giippa-burga-product', GiippaBurgaProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
